import {connect} from 'react-redux'

export default connect((state, props) => {
    return {
        user: state.connections.listed.find(con => con.id == props.userId),
        isMe: props.userId == state.session.user.id,
    };
});
